export enum PrismaOperator {
  EQUALS = 'equals',
  NOT = 'not:equals',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not:contains',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  NULL = 'null',
  NOT_NULL = 'NOT_null',
}

export const OPERATOR_LABELS: Record<PrismaOperator, string> = {
  [PrismaOperator.EQUALS]: 'is',
  [PrismaOperator.NOT]: 'is not',
  [PrismaOperator.CONTAINS]: 'contains',
  [PrismaOperator.NOT_CONTAINS]: 'does not contain',
  [PrismaOperator.GT]: '>',
  [PrismaOperator.GTE]: '>=',
  [PrismaOperator.LT]: '<',
  [PrismaOperator.LTE]: '<=',
  [PrismaOperator.NULL]: 'is empty',
  [PrismaOperator.NOT_NULL]: 'is not empty',
};

export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR',
}

export enum FieldKind {
  ENUM = 'enum',
  OBJECT = 'object',
}

export enum FieldType {
  STRING = 'String',
  INT = 'Int',
  FLOAT = 'Float',
  DATE = 'DateTime',
  BOOLEAN = 'Boolean',
  BIGINT = 'BigInt',
  DECIMAL = 'Decimal',
  JSON = 'Json',
}
